import contentfulGql from 'js/lib/contentfulGql';

const SeoContentHubPageBreadcrumbLinkFieldsFragment = contentfulGql`#graphql
  fragment SeoContentHubPageBreadcrumbLinkFields on SeoContentHubPage {
    slug
    countryCode
  }
`;

const ArticleLinkFragment = contentfulGql`#graphql
  fragment ArticleLink on ArticleBodyLinks {
    assets {
      block {
        title
        description
        url(transform: {
          width: 1500,
          quality: 60
        })
        width
        height
        sys {
          id
        }
      }
    },
    entries {
      block {
        __typename
        sys {
          id
        }
        ... on Project {
          title
          description
        }
        ... on ArticlesHighlight {
          body {
            json
          }
        }
        ... on ArticlesVlpEmbed {
          url
          videoTimestamp
          videoDescription
          embedType
        }
        ... on Faq {
          question
          answer
        }
        ... on ArticlesDegreeRecommendations {
          productType
          category
        }
        ... on ArticlesPromoUnit {
          type
        }
        ... on ArticlesImageLink {
          link
          width
          image {
            title
            description
            url
            width
            height
            sys {
              id
            }
          }
        }
        ... on ArticlesVideoEntry {
          title
          externalEmbedVideoUrl
          previewImage {
            title
            description
            url
            contentType
            sys {
              id
            }
          }
          video {
            title
            description
            url
            contentType
            sys {
              id
            }
          }
          socialMediaEmbed
        }
      }
    }
  }
`;

export const ArticleFieldsFragment = contentfulGql`#graphql
  ${ArticleLinkFragment}
  ${SeoContentHubPageBreadcrumbLinkFieldsFragment}
  fragment ArticleFields on Article {
    title
    slug
    intro
    targetKeyword
    localizedCountryCode
    featuredImage {
      title
      description
      width
      height
      url(transform: {
        width: 1500,
        height: 680,
        resizeStrategy: FILL,
        resizeFocus: FACES,
        format: JPG_PROGRESSIVE,
        quality: 60
      })
    }
    featuredImageLink
    hideFeaturedImage
    body {
      json
      links {
        ...ArticleLink
      }
    }
    relatedArticlesCollection {
      items {
        title
        slug
        localizedCountryCode
        localizedLanguageCode
          sys {
            publishedAt
          }
      }
    }
    sources {
      json
    }
    authorsCollection {
      items {
        sys {
          id
        }
        name
        jobTitle
        slug
        description
        externalWebsites
        image {
          sys {
            id
          }
          url
        }
      }
    }
    category
    subcategory
    tags
    metaTitle
    metaDescription
    sys {
      firstPublishedAt
      publishedAt
    }
    primaryCategory {
      name
      pageDataCollection(where: { countryCode_in: [$countryCode, "global"] }) {
        items {
          ...SeoContentHubPageBreadcrumbLinkFields
        }
      }
    }
    subCategoryCollection(limit: 1) {
      items {
        name
        pageDataCollection(where: { countryCode_in: [$countryCode, "global"] }) {
          items {
            ...SeoContentHubPageBreadcrumbLinkFields
          }
        }
      }
    }
  }
`;
